import { render, staticRenderFns } from "./adImg.vue?vue&type=template&id=c252191a&scoped=true&"
import script from "./adImg.vue?vue&type=script&lang=js&"
export * from "./adImg.vue?vue&type=script&lang=js&"
import style0 from "./adImg.vue?vue&type=style&index=0&id=c252191a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252191a",
  null
  
)

export default component.exports